import { z } from "zod";
import { gql } from "graphql-request";

const RelatedMediaItem = z.object({
  id: z.string(),
  title: z.string().optional(),
  label: z.string().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
});

export const RelatedMedia = z.object({
  relatedMedia: z.array(RelatedMediaItem).nullable(),
});

export type RelatedMedia = z.infer<typeof RelatedMedia>;
export type RelatedMediaItem = z.infer<typeof RelatedMediaItem>;

export const RelatedMediaFragment = gql`
  fragment RelatedMediaFragment on RelatedMedia {
    relatedMedia
  }
`;
